import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.b('logo')),
      innerHTML: _ctx.displayedLogo
    }, null, 10, _hoisted_1),
    _createElementVNode("h1", {
      class: _normalizeClass(_ctx.b('title'))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("Объединяя международные рынки")) + " ", 1),
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("Расширяя возможности глобальных трейдеров")), 1)
    ], 2)
  ], 2))
}